import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGIN } from '../helpers/Constant';
import { FaAngleRight } from 'react-icons/fa6';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

function OnBoarding() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [showTrialModal, setShowTrialModal] = useState(false);
    const [trialAssessment, setTrialAssessment] = useState({});

    const handleStartGame = async () => {
        window.location.href = "uniwebview://openGame?name=trial";
    }

    window.onGameClosed = async function (calories, time, score, heartbeat, accuracy, sessionId, gameName) {
        const setTrialAssessmentData = {
            'accuracy': accuracy,
            'burnedCal': calories,
            'heartbeat': heartbeat,
            'time': time,
            'score': score,
            'sessionId': sessionId,
            'gameName': gameName,
            'currentDate': moment().valueOf()
        }
        setTrialAssessment(setTrialAssessmentData);
        localStorage.setItem('trialData', JSON.stringify(setTrialAssessmentData));
        setShowTrialModal(true);
    };

    const goToDailyTarget = async () => {
        navigate(`/${LOGIN}`, { replace: true });
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(parseFloat(seconds) / 60);
        const secondsRemaining = seconds % 60;
        return `${minutes}:${secondsRemaining < 10 ? '0' : ''}${secondsRemaining}`;
    };

    return (
        <div className='onboarding_wrapper px-0 pb-0 h-100'>
            <div className='d-flex flex-column h-100 position-relative'>
                <div className='d-flex justify-content-center align-items-center position-relative h-100 overflow-hidden'>
                    <div className='logo_wrapper text-center w-100'>
                        <img src='../images/muvelogo.png' alt="MUVE" />
                    </div>
                    <div className='onboarding_round_wrapper position-absolute top-50 start-50 translate-middle'>
                        <div className='onboarding_round onboarding_round_1 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                        <div className='onboarding_round onboarding_round_2 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                        <div className='onboarding_round onboarding_round_3 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                        <div className='onboarding_round onboarding_round_4 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                    </div>
                </div>

                <div className='onboarding_content position-absolute bottom-0 start-0 w-100'>
                    <h2 className='h5 text-white mb-4'>Start Your Fitness Journey</h2>
                    <button className='new_user_button fw-bold btn bg-warning w-100 p-3 mb-3' onClick={handleStartGame}>{t('New User')}</button>
                    <button className='account_button fw-bold btn w-100' onClick={() => navigate(`/${LOGIN}`)}>{t('Already have an account')}</button>
                </div>
            </div>
            {/* trail modal */}
            <div className={`modal ${showTrialModal ? 'show' : ''}`} style={{ display: showTrialModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered trail_modal m-auto">
                    <div className="modal-content trail_modal_content">
                        <div className="modal-header py-3 justify-content-center border-0">
                            <h5 className="modal-title fw-bold" id="exampleModalLabel">{t('Trial assessment Result')}</h5>
                        </div>
                        <div className="modal-body trail_modal_body py-0">
                            <ul className='d-flex justify-content-center px-3 py-2 m-0'>
                                <li className='col-4 text-center'>
                                    <h4 className='my-2'>{t('Timer')}</h4>
                                    <h2 className='mb-2'>{(trialAssessment && trialAssessment.time) ? formatTime(trialAssessment.time) : 0}{(trialAssessment && trialAssessment.time && trialAssessment.time > 900) ? <IoIosArrowDown /> : (trialAssessment && trialAssessment.time) ? <IoIosArrowUp /> : null}</h2>
                                </li>
                                <li className='col-4 text-center'>
                                    <h4 className='my-2'>{t('Accuracy')}</h4>
                                    <h2 className='mb-2'>{(trialAssessment && trialAssessment.accuracy) ? trialAssessment.accuracy : 0}%{(trialAssessment && trialAssessment.accuracy && trialAssessment.accuracy > 50) ? <IoIosArrowDown /> : (trialAssessment && trialAssessment.accuracy) ? <IoIosArrowUp /> : null}</h2>
                                </li>
                                <li className='col-4 text-center'>
                                    <h4 className='my-2'>{t('Burned')}</h4>
                                    <h2 className='mb-2 arrow_down'>{(trialAssessment && trialAssessment.burnedCal) ? trialAssessment.burnedCal : 0}</h2>
                                </li>
                            </ul>
                        </div>
                        <div className="modal-footer border-0 p-4 pe-3 align-items-center justify-content-between">
                            <div className='d-flex align-items-center m-0'>
                                <span className='ring_loading small'></span>
                                <p className='m-0 ms-3 ps-1'>{t('Calculating your daily target')}</p>
                            </div>
                            <button onClick={goToDailyTarget} className='bg-transparent p-0 m-0 border-0 fw-bold d-flex align-items-center'><span className='d-inline'>{t('Go')}</span><FaAngleRight /></button>
                        </div>
                    </div>
                </div>
            </div>

            {showTrialModal && <div className="modal-backdrop show"></div>}
        </div>
    )
}

export default OnBoarding;